import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { IConfig, IConfiguration } from '@microsoft/applicationinsights-web';
import { LocalStorageService } from 'ngx-webstorage';
import { Utilities } from '../utilities';
import { lastValueFrom } from 'rxjs';

export const baseUrl = Utilities.baseUrl();
export const BASE_URL_TOKEN = new InjectionToken<string>(baseUrl);

export function initializerFactory(configRetriever: AppInitializerService, baseUrl: string): any {
    const promise = configRetriever.getConfiguration(baseUrl);

    return () => promise;
}

@Injectable({
    providedIn: 'root'
})
export class AppInitializerService {
    static configuration: IExternalConfiguration;
    static clientId: string;
    private http: HttpClient;

    get clientId() {
        return this.localStorageService.retrieve('clientId');
    }

    constructor(httpHandler: HttpBackend, private localStorageService: LocalStorageService) {
        this.http = new HttpClient(httpHandler);

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop as string),
        });

        const _clientId = params['clientId']

        // Set or reset clientId
        if ((this.clientId == null && _clientId != null) || (this.clientId != null && _clientId != null && this.clientId != _clientId)) {
            this.localStorageService.store('clientId', _clientId);
        }
    }

    async getConfiguration(baseUrl: string) {
        const url = `${baseUrl}configuration`;
        AppInitializerService.configuration = await lastValueFrom(this.http.get<IExternalConfiguration>(url));
    }
}

export interface IExternalConfiguration {
    webAppApiBaseUrl: string;
    kofaxCaptureBaseUrl: string;
    documentInterviewApiBaseUrl: string;
    interviews: IInterviewConfig[];
    actions: IActionConfig[];
    webAppApi: IWebAppApiConfigs;
    instrumentationKey: string;
    instrumentationClientName: string;
    appInsightsConfiguration?: IConfiguration & IConfig;
    webViewerPDFTronKey: string;
    classificationInterview: IInterviewConfiguration;
    memberSessionExpirationMinutes: string;
    telephonyParametersExpirationMinutes: string;
    searchDebounceTime: number;
    permissionSettings: IPermissionSettings;
    repositoryManagerServicePageSize: number;
    notificationLoadIntervalMinutes: number;
    googleServiceApiKey: string;
}

export interface IPermissionSettings {
    registrationExpiryMinutes: number;
    evaluationIntervalMinutes: number;
}

export interface IWebAppApiConfigs {
    case: boolean;
    facility: boolean;
    note: boolean;
    phone: boolean;
    product: boolean;
    telephony: boolean;
    address: boolean;
    document: boolean;
    tenant: boolean;
    activeDirectory: boolean;
    location: boolean;
    member: boolean;
    processManager: boolean;
    community: boolean;
    user: boolean;
}

export interface IPreviewFeature {
    id: string;
    displayName: string;
    visible: boolean;
    active: boolean;
    enabled: boolean;
    data?: any;
    hash?: string;
    timeStamp?: Date;
    cacheDuration?: number;
    inScope: boolean;
}

export interface IInterviewConfig {
    packageName: string;
    packageVersion: string;
}

export interface IInterviewConfiguration {
    packageName: string;
    versionNumber: string;
}

export interface IActionConfig {
    packageName: string;
    packageVersion: string;
}
